export default __webpack_public_path__ + "static/media/patient.1f5abfe4.png";